import { memo, useCallback } from "react";
import PropTypes from "prop-types";
import { FormattedMessage, useIntl } from "react-intl";
import isEmpty from "lodash/isEmpty";
import { PRODUCTS_FILTERS_KEY } from "app/constants";
import IconArrowDown from "app/pages/.shared/static/icons/IconArrowDown";
import classNames from "classnames";
import "./ProductsMasterFilter.scss";

const ProductsMasterFilterComponent = ({
	resetAllProductsFilter,
	scrollToListingHeader,
	toggleAsideProductFilters,
	productsFilters = {},
}) => {
	const intl = useIntl();

	const handleClearFilterButtonClick = useCallback(() => {
		resetAllProductsFilter();
		scrollToListingHeader();
	}, []);

	const activeFilterValues = Object.keys(productsFilters)
		.map(productFilter => {
			if (productFilter === PRODUCTS_FILTERS_KEY.MONTH) {
				return intl.formatDate(Number(productsFilters.month), {
					timeZone: "UTC",
					month: "long",
					year: "numeric",
				});
			}

			if (productFilter === PRODUCTS_FILTERS_KEY.DISCOUNT_PERCENTAGE) {
				return intl.formatMessage(
					{ id: "listing.filter.percentage" },
					{ percentage: "50" }
				);
			}

			return productsFilters[productFilter];
		})
		.join(", ");

	const isFilterActive = !isEmpty(productsFilters);

	const filterClassName = classNames("products-master-filter", {
		"products-master-filter--active": isFilterActive,
	});

	return (
		<div className={filterClassName}>
			<div className="products-master-filter__value" onClick={toggleAsideProductFilters}>
				{isFilterActive ? (
					activeFilterValues
				) : (
					<FormattedMessage id="listing.filter.empty.button.label" />
				)}
			</div>

			{isFilterActive ? (
				<i
					className="icon icon--circle-cross-black"
					onClick={handleClearFilterButtonClick}
				/>
			) : (
				<IconArrowDown
					height={15}
					width={25}
					className="products-master-filter__icon-dropdown"
					onClick={toggleAsideProductFilters}
				/>
			)}
		</div>
	);
};

ProductsMasterFilterComponent.propTypes = {
	toggleAsideProductFilters: PropTypes.func,
	resetAllProductsFilter: PropTypes.func,
	productsFilters: PropTypes.object,
	scrollToListingHeader: PropTypes.func,
};

export const ProductsMasterFilter = memo(ProductsMasterFilterComponent);
